import Breadcrumb from "../components/Breadcrumb";
import ClientBranches from "../components/ClientBranches";

const ClientBranchesPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Client Branches" />

      <ClientBranches />
    </>
  );
};

export default ClientBranchesPage;
